import React, { Component, createRef } from "react";
import { Icon, Modal, Switch, Table, Tooltip } from "antd";
import update from "immutability-helper";
import { DndProvider, DragSource, DropTarget } from "react-dnd";
import { HTML5Backend } from "react-dnd-html5-backend";
import { withTranslation } from "react-i18next";
import * as Func from "../../../../../helpers/functions";
import VinwonderTagGroup from "models/VinWonderTagGroup";
import EllipsisText from "containers/backend/common/component/EllipsisText";
import { StatusComponent } from "containers/backend/common/component/Index";
import { FlagIcons } from "containers/backend/common/component/TranslateButton";
import { Link } from "react-router-dom";
import { PATHS } from "constants/Define";
import i18n from "constants/initLng";
import { getContentLanguage } from "../../../../../utils/commonUtils";
import { normalizeVinWonderTagGroups } from "../helpers";

const type = "DraggableBodyRow";

const rowSource = {
  beginDrag(props) {
    return { index: props.index };
  },
};

const rowTarget = {
  drop(props, monitor) {
    const dragIndex = monitor.getItem().index;
    const hoverIndex = props.index;
    if (dragIndex === hoverIndex) return;

    props.moveRow(dragIndex, hoverIndex);
    monitor.getItem().index = hoverIndex;
  },
};

class DraggableBodyRow extends Component {
  ref = createRef();

  render() {
    const {
      isOver,
      isDragging,
      connectDragSource,
      connectDropTarget,
      moveRow,
      className,
      style,
      siteType,
      ...restProps
    } = this.props;

    const rowStyle = {
      cursor: "move",
      ...style,
    };

    return connectDragSource(
      connectDropTarget(
        <tr
          ref={this.ref}
          className={className}
          style={rowStyle}
          {...restProps}
        />
      )
    );
  }
}

const DraggableRow = DropTarget(type, rowTarget, (connect) => ({
  connectDropTarget: connect.dropTarget(),
}))(
  DragSource(type, rowSource, (connect, monitor) => ({
    connectDragSource: connect.dragSource(),
    isDragging: monitor.isDragging(),
  }))(DraggableBodyRow)
);

const ListCols = [
  "orderCode",
  "nameFollowSupplier",
  "codeIndex",
  "description",
  "supplierNamesConfiged",
  "totalSkuConfiged",
  "isActive",
  "isDefault",
  "translations",
];
const ModelFields = Object.getOwnPropertyNames(new VinwonderTagGroup());

class CategoryListWithDrag extends Component {
  state = {
    data: normalizeVinWonderTagGroups(
      this.props.dataRender || [],
      getContentLanguage()
    ),
    titleItemTable: Func.getTitleTable(ListCols, ["action"], ["description"]),
    modelItem: ModelFields,
    confirmChangeDefault: false,
    componentTable: {
      orderCode: {
        with: 70,
        key: "orderCode",
        render: (text, record) => {
          return (
            <div
              style={{
                cursor: "move",
                display: "flex",
                alignItems: "center",
                gap: "50px",
              }}
            >
              <Icon type="menu" /> {Number(record.order)}
            </div>
          );
        },
      },
      nameFollowSupplier: {
        key: "nameFollowSupplier",
        render: (name, record) =>
          record.name && (
            <EllipsisText
              title={record.name}
              content={record.name}
              contentMaxWidth={600}
              overlayClassName={"max-width-500"}
              overlayComponent={Tooltip}
            />
          ),
      },
      supplierNamesConfiged: {
        key: "supplierNamesConfiged",
        render: (text, record) => (
          <Tooltip title={record.supplierNamesConfiged}>
            <Icon type="info-circle" />
          </Tooltip>
        ),
      },
      codeIndex: {
        key: "code",
        render: (text, record) => <p>{record.code}</p>,
      },
      totalSkuConfiged: {
        key: "totalSkuConfiged",
      },
      isDefault: {
        key: "isDefault",
        align: "center",
        render: (isDefault, record) => (
          <Switch
            size="small"
            defaultChecked={isDefault}
            onChange={(checked) => {
              this.onChangeDefault(checked, record);
            }}
          />
        ),
      },
      isActive: {
        key: "isActive",
        render: (isActive) => (
          <StatusComponent
            color={isActive ? "green" : "red"}
            label={
              isActive
                ? this.props.t("item.promotions.active")
                : this.props.t("item.promotions.deactive")
            }
          />
        ),
      },
      translations: {
        key: "translations",
        render: (text, record) => <FlagIcons languages={record.translations} />,
      },
      action: {
        width: 100,
        align: "center",
        key: "action",
        render: (text, record) => {
          if (this.props.permisions && this.props.permisions.allowUpdate) {
            return (
              <Link
                to={Func.getPathWithParams(PATHS.TAG_GROUP_VW.DETAIL.path, {
                  id: record.id,
                })}
                className={`mr-2`}
              >
                <Icon type="form" className="fs20 mr-1" />
              </Link>
            );
          }
        },
      },
    },
    dataChangeDefault: {
      supplierId: this.props.supplierId,
      vinWonderTagGroupId: null,
      isDefault: false,
      siteType: Number(this.props.siteType),
    },
  };

  components = {
    body: {
      row: DraggableRow,
    },
  };

  moveRow = (dragIndex, hoverIndex) => {
    const { data } = this.state;
    const dragRow = data[dragIndex];
    const newState = update(this.state, {
      data: {
        $splice: [
          [dragIndex, 1],
          [hoverIndex, 0, dragRow],
        ],
      },
    });
    const dataWillBeSent = {
      supplierId: this.props.supplierId,
      tagGroupOrder: newState.data.map((item, index) => ({
        vinWonderTagGroupId: item.id,
        order: index + 1,
      })),
      siteType: Number(this.props.siteType),
    };
    this.props.onDragToOrder(dataWillBeSent);
    this.setState(newState);
  };

  componentDidUpdate(prevProps) {
    if (prevProps.dataRender !== this.props.dataRender) {
      this.setState({
        data: normalizeVinWonderTagGroups(
          this.props.dataRender || [],
          getContentLanguage()
        ),
      });
    }
  }

  onChangeDefault = (checked, record) => {
    const dataAlreadyDefault = (this.props.dataRender || []).find(
      (item) => item.isDefault
    );
    if (checked && dataAlreadyDefault) {
      this.setState({
        confirmChangeDefault: true,
        dataChangeDefault: {
          supplierId: this.props.supplierId,
          vinWonderTagGroupId: record.id,
          isDefault: checked,
          siteType: Number(this.props.siteType),
        },
      });
    }
    if (checked && !dataAlreadyDefault) {
      this.props.onUpdateDefaultTag({
        supplierId: this.props.supplierId,
        vinWonderTagGroupId: record.id,
        isDefault: checked,
        siteType: Number(this.props.siteType),
      });
    }

    if (!checked) {
      this.props.onUpdateDefaultTag({
        supplierId: this.props.supplierId,
        vinWonderTagGroupId: record.id,
        isDefault: checked,
        siteType: Number(this.props.siteType),
      });
    }
  };

  onSubmitChangeDefault = () => {
    this.props.onUpdateDefaultTag(this.state.dataChangeDefault);
    this.setState({ confirmChangeDefault: false, dataChangeDefault: {
      supplierId: this.props.supplierId,
      vinWonderTagGroupId: null,
      isDefault: false,
      siteType: Number(this.props.siteType),
    } });
  };

  onCancelChangeDefault = () => {
    this.setState({
      confirmChangeDefault: false,
      dataChangeDefault: {
        supplierId: this.props.supplierId,
        vinWonderTagGroupId: null,
        isDefault: false,
        siteType: Number(this.props.siteType),
      },
    });
  };

  componentWillUnmount() {
    this.setState({
      confirmChangeDefault: false,
      dataChangeDefault: {
        supplierId: this.props.supplierId,
        vinWonderTagGroupId: null,
        isDefault: false,
        siteType: null,
      },
    });
  }

  render() {
    const { titleItemTable, componentTable, data, confirmChangeDefault } =
      this.state;

    return (
      <>
        <DndProvider backend={HTML5Backend} key={Math.random()}>
          <Table
            columns={Func.columnsTable({
              titleTable: titleItemTable,
              component: componentTable,
              itemName: "vinwondertaggroup",
            })}
            dataSource={data}
            components={this.components}
            rowKey={(record) => record.id}
            onRow={(_, index) => ({
              index,
              moveRow: this.moveRow,
            })}
          />
          <Modal
            title={i18n.t("vinwondertaggroup.confirm.changeDefault", {
              defaultValue: "Xác nhận đổi Nhóm mặc định?",
            })}
            visible={confirmChangeDefault}
            onOk={this.onSubmitChangeDefault}
            onCancel={this.onCancelChangeDefault}
            okText={i18n.t("action.ok", { defaultValue: "Có" })}
            cancelText={i18n.t("action.cancel", { defaultValue: "Không" })}
          >
            <p>
              {i18n.t("vinwondertaggroup.require.changeDefault", {
                defaultValue:
                  "Chỉ được chọn 1 nhóm Sản phẩm là mặc định cho nhà cung cấp này.",
              })}
            </p>
          </Modal>
        </DndProvider>
      </>
    );
  }
}

export default withTranslation()(CategoryListWithDrag);
